// src/utils/offlineQueue.js
// Queues API mutations when offline and replays them when back online

const QUEUE_KEY = 'sk-offline-mutation-queue';

export function enqueueRequest({ method, url, data, headers = {} }) {
  const queue = getQueue();
  queue.push({ method, url, data, headers, timestamp: Date.now(), id: Math.random().toString(36).slice(2) });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  console.log(`📦 Queued offline request: ${method} ${url}`);
}

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function clearQueue() {
  localStorage.removeItem(QUEUE_KEY);
}

export function getPendingCount() {
  return getQueue().length;
}

export async function replayQueue(authToken) {
  const queue = getQueue();
  if (queue.length === 0) return { replayed: 0, failed: 0 };

  let replayed = 0;
  let failed = 0;
  const remaining = [];

  for (const item of queue) {
    try {
      const res = await fetch(item.url, {
        method: item.method,
        headers: {
          'Content-Type': 'application/json',
          ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
          ...item.headers
        },
        body: item.data ? JSON.stringify(item.data) : undefined
      });
      if (res.ok) {
        replayed++;
        console.log(`✅ Replayed: ${item.method} ${item.url}`);
      } else {
        failed++;
        remaining.push(item);
      }
    } catch {
      failed++;
      remaining.push(item);
    }
  }

  localStorage.setItem(QUEUE_KEY, JSON.stringify(remaining));
  return { replayed, failed };
}
